import React from 'react'
import { HelpCircleIcon } from 'lucide-react'
import Typography from '../atoms/Typography'

interface SupportContainerProps {
  buttonText: string
  onRequestSupport?: () => void
  className?: string
  isCollapsed?: boolean
}

const SupportContainer: React.FC<SupportContainerProps> = ({
  buttonText,
  onRequestSupport,
  className = '',
  isCollapsed = false,
}) => {
  const handleRequestSupport = () => {
    if (onRequestSupport) {
      onRequestSupport()
    }
  }

  return (
    <div className={`flex justify-center px-4 ${className}`}>
      <button
        onClick={handleRequestSupport}
        className={`
          group relative flex items-center justify-center
          ${isCollapsed ? 'h-[24px] w-[24px] p-0' : 'h-[32px] flex-1 px-5'}
          rounded-full
          text-sm font-medium
          transition-opacity
        `}
        style={{
          background: `
            linear-gradient(#27292C, #27292C) padding-box,
            linear-gradient(216deg, #329175 -32.48%, #F5F5DC 132.11%) border-box
          `,
          border: isCollapsed ? '2px solid transparent' : '1px solid transparent',
          color: '#f9fafb',
        }}
      >
        {/* Overlay on hover */}
        <span className="absolute inset-0 rounded-full bg-black/20 opacity-0 transition-opacity group-hover:opacity-100" />

        {isCollapsed ? (
          <HelpCircleIcon className="relative h-5 w-5 text-white [&>circle]:hidden" />
        ) : (
          <Typography variant="xs-medium" className="relative">
            {buttonText}
          </Typography>
        )}
      </button>
    </div>
  )
}

export default SupportContainer
